import React, { useState } from "react";
import Add from "../../assets/img/add.svg";
import TextInput from "../TextInput";
import Button from "../Button";
import PlusCircle from "../../assets/img/plus-circle.svg";
import {
  checkEmailValid,
  checkNonEmptyValues,
} from "../../utils/validation";
import { fireEmptyInputSwal, fireInvalidEmailSwal } from "../../utils/swals";

const Adder = ({ setAddedPeriodistas, setSelectedPeriodistas }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [periodista, setPeriodista] = useState({
    nombre: "",
    cargo: "",
    dni: "",
    mail: "",
    celular: "",
  });

  const handleSubmit = () => {
    setAddedPeriodistas((prevState) => [...prevState, periodista]);
    setSelectedPeriodistas((prevState) => [...prevState, periodista]);
    setPeriodista({
      nombre: "",
      cargo: "",
      dni: "",
      mail: "",
      celular: "",
    });
    setIsOpen(false);
  };

  const checkValuesAndSubmit = () => {
    if (!checkNonEmptyValues(periodista)) {
      fireEmptyInputSwal();
    } else if (!checkEmailValid(periodista.mail)) {
      fireInvalidEmailSwal();
    } else {
      handleSubmit();
    }
  };

  return (
    <div className="adder">
      <div className={`add-accordion ${isOpen ? "open" : "close"}`}>
        <div
          className="head"
          onClick={() => setIsOpen((prevState) => !prevState)}
        >
          <span>Ingresar personal de prensa nuevo</span>
          <img src={Add} alt="Agregar" />
        </div>
        <div className="body">
          <div className="d-col">
            <div className="d-row">
              <TextInput
                placeholder={"Nombre y apellido"}
                onChange={(e) =>
                  setPeriodista((prevState) => ({
                    ...prevState,
                    nombre: e.target.value,
                  }))
                }
                value={periodista.nombre}
                type={"text"}
              />
            </div>
            <div className="d-row">
              <TextInput
                placeholder={"DNI"}
                onChange={(e) =>
                  setPeriodista((prevState) => ({
                    ...prevState,
                    dni: e.target.value,
                  }))
                }
                noDots={true}
                value={periodista.dni}
              />
              <TextInput
                placeholder={"Cargo"}
                onChange={(e) =>
                  setPeriodista((prevState) => ({
                    ...prevState,
                    cargo: e.target.value,
                  }))
                }
                value={periodista.cargo}
              />
            </div>
            <div className="d-row">
              <TextInput
                placeholder={"Numero de teléfono"}
                onChange={(e) =>
                  setPeriodista((prevState) => ({
                    ...prevState,
                    celular: e.target.value,
                  }))
                }
                value={periodista.celular}
              />
              <TextInput
                placeholder={"E-mail"}
                onChange={(e) =>
                  setPeriodista((prevState) => ({
                    ...prevState,
                    mail: e.target.value,
                  }))
                }
                value={periodista.mail}
                type={"email"}
              />
            </div>
          </div>
          <div className="mt-5">
            <Button variant={"outline-btn"} onClick={checkValuesAndSubmit}>
              <img src={PlusCircle} alt="Mas" />
              <span>Agregar personal</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Adder;
